import { compactArray } from '@mews/fp';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { ProcessPaymentType } from '../../../../payment';

export const useAllowedPaymentMethodsForInvoices = () => {
    const { data: terminals = [] } = useRepositoryQuery('paymentTerminals', 'getAll', {});

    const terminalPaymentAllowed = terminals ? terminals.some((t) => t.isStripeTerminal || t.isAdyenTerminal) : false;

    return compactArray([
        ProcessPaymentType.CashPayment,
        ProcessPaymentType.ExternalPayment,
        ProcessPaymentType.GatewayPayment,
        ProcessPaymentType.ExternalCardPayment,
        terminalPaymentAllowed ? ProcessPaymentType.MewsTerminalPayment : null,
    ]);
};
